import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from 'components/FormError';
import InputField from 'components/InputField';
import SelectField from 'components/SelectField';

import styles from './styles.module.scss';

let ValidatePortForm = ({ quickVendors, handleSubmit, error, invalid }) => {
  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.inputs}>
        <Field component={InputField} name="mdn" label="MDN*" />
        <Field
          component={SelectField}
          name="vendor"
          label="Vendor*"
          options={quickVendors}
          empty="Select vendor"
        />
      </div>

      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-primary" disabled={invalid}>
        Validate Port
      </button>
    </form>
  );
};

const validate = (values) => {
  let errors = {};

  const requiredFields = ['mdn', 'vendor'];
  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = 'Required';
    }
  });

  return errors;
};

ValidatePortForm = reduxForm({
  form: 'validatePortForm',
  validate,
})(ValidatePortForm);

export default ValidatePortForm;
